import React, { useContext } from "react";
import "../App.css";
import "animate.css";
import ScrollAnimation from "react-animate-on-scroll";
// import Animate from 'animate.css-react';
import "animate.css/animate.compat.css"; // Import Animate.css styles
import logo from "../images/logo.png";

// import 'animate.css/animate.css';
import GreenArrow from "../images/greenarrow.png";
// import HomeSegment2IMG from "../images/homeSegment2IMG.jpg";
// import GgreenArrow from "../images/GgreenArrow.png";

import homeSegment3img1 from "../images/homeSegment3img1s.jpg";
import homeSegment3img2 from "../images/homeSegment3img2.jpg";
import homeSegment3img3 from "../images/homeSegment3img3.jpg";
import homeSegment3img4 from "../images/homeSegment3img4.jpg";
import homeSegment4arrow from "../images/homeSegment4arrow.png";
import homeSegment5IMG from "../images/homeSegment5IMG.jpg";
import secondimg from "../images/secondimg.jpg";
import uprightarrow from "../images/uprightarrow.png";

// import partner1 from "../images/partner1.PNG";
// import partner2 from "../images/partner2.PNG";
// import partner3 from "../images/partner3.PNG";

import heroboximg1 from "../images/heroboximg1.jpg";
import heroboximg2 from "../images/newheroboximg2.jpg";
import heroboximg3 from "../images/newheroboximg3.jpg";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Stats from "../components/stats";
import { SectionsContext } from "../store/section-context";
import FAQS from "../components/faq";
import Reviews from "../components/reviews";

function Home() {
  const { home } = useContext(SectionsContext);
  const heroImages = [heroboximg1, heroboximg2, heroboximg3];
  const homeSegment3imgs = [
    homeSegment3img1,
    homeSegment3img2,
    homeSegment3img3,
    homeSegment3img4,
  ];
  const { meta, hero, about, whatWeDo, whyChooseUs, partners, faq } = home;

  return (
    <>
      <Helmet>
        {/* Title and Meta Description */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta
          property="og:url"
          content="https://www.brookshealthandcare.com/"
        />
        <meta property="og:image" content={logo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Brooks Health and Care" />
        <meta property="og:locale" content="en_GB" />{" "}
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={logo} />
        <link
          rel="canonical"
          href="https://www.brookshealthandcare.com/"
        />{" "}
        <meta name="author" content="Brooks Health and Care" />
        <meta name="robots" content="index, follow" />{" "}
      </Helmet>

      <div>
        {/* ----------------HERO BOX----------------- */}
        <div className="herobox">
          <div
            id="carouselExampleSlidesOnly"
            className="carousel carousel-fade slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-indicators">
              {hero.uris.map((uri, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#carouselExampleSlidesOnly"
                  data-bs-slide-to={index}
                  className={index === 0 ? "active" : ""}
                  aria-current={index === 0 ? "true" : undefined}
                  aria-label={`Slide ${index + 1}`}
                ></button>
              ))}
            </div>
            <div className="carousel-inner">
              {hero.uris.map((uri, index) => (
                <div
                  key={index}
                  className={`carousel-item ${index === 0 ? "active" : ""}`}
                >
                  <img
                    src={uri || heroImages[index % heroImages.length]}
                    className="d-block w-100 heroimg"
                    alt="Peace of mind."
                  />
                  <div className="carousel-caption  d-block">
                    <div className="lhsmobile">
                      <div className="lhsheading">
                        {" "}
                        <span className="thick-dot"></span>{" "}
                        <span className="ps-1">{hero.headline}</span>{" "}
                      </div>
                      <div className="lhssubtitle">{hero.subheadline}</div>
                    </div>
                    <div className="rhs pb-5">
                      <div className="rhsdesc">{hero.description}</div>
                      <div className="rhsbtn">
                        <div className="pt-3">
                          <a className="testimonialbtn py-3" href="/contact">
                            <span className="pe-2 ">{hero.cta}</span>{" "}
                            <img
                              src={uprightarrow}
                              alt="arrow"
                              className="homeSegment6testimoialarrow"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* --------------HOME SEGMENT 1-------------- */}
        <div className="homeSegment1  p-md-5 p-4">
          <div className="d-flex">
            <div className="homeSegment1aboutusline"></div>
            <div className="homeSegment1aboutus ps-2">{about.heading}</div>
          </div>
          <div
            className="homeSegment1text pt-4"
            dangerouslySetInnerHTML={{ __html: about.summary }}
          ></div>
          <div className="homeSegment1text pt-3"></div>
          <div className="horizontal-border-line pt-5"></div>
        </div>

        {/* --------------HOME SEGMENT 2-------------- */}
        <Stats />
        {/* --------------HOME SEGMENT 3-------------- */}
        <div className="homeSegment3  p-md-5 p-4">
          <div className="d-flex">
            <div className="homeSegment1aboutusline"></div>
            <div className="homeSegment1aboutus ps-2">{whatWeDo.heading}</div>
          </div>
          <div className="homeSegment3intro py-3">{whatWeDo.intro}</div>
          <div className="homeSegment3container pt-2">
            {whatWeDo.items.map(({ title, description, uri }, index) => (
              <ScrollAnimation
                key={index}
                className="homeSegment3box p-3"
                animateIn="bounceInLeft"
                animationOut="fadeOut"
              >
                <div className="homeSegment3imgcontainer">
                  <img
                    className="homeSegment3img"
                    src={
                      uri || homeSegment3imgs[index % homeSegment3imgs.length]
                    }
                    alt="careworker"
                  />
                </div>
                <div className="homeSegment3title py-2"> {title}</div>
                <div className="homeSegment3subtitle">{description}</div>
                <a
                  href="/contact"
                  className="homeSegment3contactcontainer pb-1 pt-4"
                >
                  <div className="homeSegment2contact pe-4">Get Started</div>
                  <div>
                    <img className="" src={GreenArrow} alt="arrow" />
                  </div>
                </a>
              </ScrollAnimation>
            ))}
          </div>
        </div>
        {/* --------------HOME SEGMENT 4-------------- */}
        <div className="homeSegment4  p-md-5 p-4">
          <div className="homeSegment4container p-4">
            <div>
              <div className="homeSegment4title">Brooks Health and Care</div>
              <div className="homeSegment4subtitle pt-2">
                Let's Discuss Your Health Needs
              </div>
            </div>
            <Link
              to={`mailto: admin@brookshealthandcare.com?subject=Interested%20In%20Services&body=Hello!%20I'm%20interested%20in...`}
              className="homeSegment4contactUs"
            >
              Contact Us <img className="ps-2" src={homeSegment4arrow} alt="" />
            </Link>
          </div>
        </div>
        {/* --------------HOME SEGMENT 5-------------- */}
        <div className="homeSegment5  p-md-5 p-4">
          <div className="d-flex">
            <div className="homeSegment1aboutusline"></div>
            <div className="homeSegment1aboutus ps-2">
              {whyChooseUs.heading}
            </div>
          </div>
          <div className="homeSegment3intro py-3">{whyChooseUs.intro}</div>

          <div className="homeSegment5container pt-3">
            <div>
              <img
                src={whyChooseUs.uris[0] || secondimg}
                alt="Care Worker"
                className="homeSegment5IMG pb-3"
              />
              <img
                src={whyChooseUs.uris[1] || homeSegment5IMG}
                alt="Care Worker"
                className="homeSegment5IMG"
              />
            </div>
            <ScrollAnimation
              className="homeSegment5container2 "
              animateIn="bounceInRight"
              animationOut="fadeOut"
            >
              {whyChooseUs.items.map(({ title, description }, index) => (
                <div className="pb-4" key={index}>
                  <div className="homeSegment5box d-flex">
                    <div className="">
                      <div className="homeSegment5title">{title}</div>
                      <div className="homeSegment5subtitle pt-3">
                        {description}
                      </div>
                    </div>
                    <Link to="/about">
                      <img src={uprightarrow} alt="arrow" />
                    </Link>
                  </div>
                </div>
              ))}
            </ScrollAnimation>
          </div>
        </div>
        {/* --------------HOME SEGMENT 6-------------- */}
        <Reviews />
        {/* ---------------HOME SEGMENT 6.5------------- */}
        <div className="homeSegment6.5  p-md-5 p-4">
          <div className="d-flex">
            <div className="homeSegment1aboutusline"></div>
            <div className="homeSegment1aboutus ps-2"> {partners.heading} </div>
          </div>
          <div className="homeSegment3intro py-3">{partners.intro}</div>
          <div className="d-md-grid partners pt-4">
            {partners.items.map(({ text, uri }, index) => (
              <div key={index} className="partner ">
                <div>{text} </div>
                <img className="partnerimg" src={uri} alt="" />
              </div>
            ))}
          </div>
        </div>
        {/* --------------HOME SEGMENT 7-------------- */}
        <FAQS data={faq} />
      </div>
    </>
  );
}

export default Home;
